import { 
    REACT_APP_OIDC_AUTHORITY,
    REACT_APP_OIDC_CLIENT_ID,
    REACT_APP_OIDC_REDIRECT_URI,
    REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI,
    REACT_APP_OIDC_RESPONSE_TYPE,
    REACT_APP_OIDC_SCOPE,
    REACT_APP_OIDC_AUTHORIZATION_ENDPOINT,
    REACT_APP_OIDC_TOKEN_ENDPOINT,
    REACT_APP_OIDC_USERINFO_ENDPOINT,
    REACT_APP_OIDC_END_SESSION_ENDPOINT,
    REACT_APP_OIDC_INTROSPECTION_ENDPOINT,
    REACT_APP_OIDC_JWKS_URI
} from './runtimeConfig';

// Default Keycloak configuration for development
const defaultConfig = {
    authority: 'https://keycloak.socmanage.com/realms/alert-management',
    client_id: 'alert-ui-client',
    redirect_uri: 'https://app.socmanage.com/callback',
    post_logout_redirect_uri: 'https://app.socmanage.com/login',
    response_type: 'code',
    scope: 'openid profile email roles',
};

export const oidcConfig = {
    authority: REACT_APP_OIDC_AUTHORITY || defaultConfig.authority,
    client_id: REACT_APP_OIDC_CLIENT_ID || defaultConfig.client_id,
    redirect_uri: REACT_APP_OIDC_REDIRECT_URI || defaultConfig.redirect_uri,
    post_logout_redirect_uri: REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || defaultConfig.post_logout_redirect_uri,
    response_type: 'code', // Force Authorization Code flow
    scope: REACT_APP_OIDC_SCOPE || defaultConfig.scope,
    
    // PKCE configuration for Authorization Code flow
    automaticSilentRenew: true,
    includeIdTokenInSilentRenew: true,
    loadUserInfo: true,
    
    // Optional endpoints - will be auto-discovered if not provided
    ...(REACT_APP_OIDC_AUTHORIZATION_ENDPOINT && { authorization_endpoint: REACT_APP_OIDC_AUTHORIZATION_ENDPOINT }),
    ...(REACT_APP_OIDC_TOKEN_ENDPOINT && { token_endpoint: REACT_APP_OIDC_TOKEN_ENDPOINT }),
    ...(REACT_APP_OIDC_USERINFO_ENDPOINT && { userinfo_endpoint: REACT_APP_OIDC_USERINFO_ENDPOINT }),
    ...(REACT_APP_OIDC_END_SESSION_ENDPOINT && { end_session_endpoint: REACT_APP_OIDC_END_SESSION_ENDPOINT }),
    ...(REACT_APP_OIDC_INTROSPECTION_ENDPOINT && { introspection_endpoint: REACT_APP_OIDC_INTROSPECTION_ENDPOINT }),
    ...(REACT_APP_OIDC_JWKS_URI && { jwks_uri: REACT_APP_OIDC_JWKS_URI })
};

export default oidcConfig;
